import { buildingIcon } from '@/svg';

export default {
	data() {
		return {
			buildingIcon
		};
	},
};